import { useObjectMemo } from "../../../hooks";

import { directDepositEnrollmentForm } from "./form";

export const useDirectDepositManualForm = () => {
  const form = directDepositEnrollmentForm.useForm();
  // To-do - send API request on success https://linear.app/narmi/issue/CDB-833
  return useObjectMemo({ form });
};
